import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { updateProfile } from "./profiles";
var mapFieldsToProfile = {
  has_previous_401k: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  previous_401k_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  has_previous_roth_401k: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  previous_roth_401k_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  has_current_401k: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  current_401k_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  has_current_roth_401k: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  current_roth_401k_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  has_current_ira: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  current_ira_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  has_current_roth_ira: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  current_roth_ira_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  cash_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  total_retirement_savings: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  brokerage_account_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  checking_account_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  savings_account_balance: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  estimated_annual_expenses: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  annual_ira_contribution: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  annual_roth_ira_contribution: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  annual_cash_contribution: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  has_401k_match: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  annual_401k_contribution_percentage: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  company_401k_contribution_match: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  company_401k_dollar_match: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  advisory_progress: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  home_ownership: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
  target_retirement_age: NwApiSDK.IDENTITY_PROFILES.FORECAST_PROFILE,
  life_expectancy: NwApiSDK.IDENTITY_PROFILES.FORECAST_PROFILE,
  expected_inflation_rate: NwApiSDK.IDENTITY_PROFILES.FORECAST_PROFILE,
  retirement_lifestyle_multiplier: NwApiSDK.IDENTITY_PROFILES.FORECAST_PROFILE,
  expected_stock_market_return: NwApiSDK.IDENTITY_PROFILES.FORECAST_PROFILE,
  expected_ss_disbursement_rate: NwApiSDK.IDENTITY_PROFILES.FORECAST_PROFILE,
  assets: NwApiSDK.IDENTITY_PROFILES.ASSETS_PROFILE,
  annual_income: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
  current_spouses_annual_income: NwApiSDK.IDENTITY_PROFILES.FINANCIAL_PROFILE,
  date_of_birth: NwApiSDK.IDENTITY_PROFILES.GLOBAL_PROFILE,
  marital_status: NwApiSDK.IDENTITY_PROFILES.GLOBAL_PROFILE,
  mailing_address: NwApiSDK.IDENTITY_PROFILES.GLOBAL_PROFILE
};
/*
 * Create a minimal set of requests to the unique
 * set of profileTypes that the given set of fields
 * may correspond to. These are bundled into a
 * synchronous chain of promises that save to identity.
 *
 * Example:
 * update = {
 *  current_401k_balance: 50000,
 *  current_roth_401k_balance: 50000,
 *  target_retirement_age: 65,
 * }
 *
 * Will result in 2 requests.
 * /investing_profile with {current_401k, current_roth}
 *
 * and
 *
 * /investing_forecast with {target_retirment_age}
 */

export var updateRetirementProfiles = function updateRetirementProfiles(dispatch, update) {
  var updates = {};
  var fields = Object.keys(update);
  fields.forEach(function (field) {
    var type = mapFieldsToProfile[field];

    if (type) {
      if (!updates[type]) {
        updates[type] = {};
      }

      updates[type][field] = update[field];
    }
  });
  var profileTypes = Object.keys(updates);
  return profileTypes.reduce(function (previous, profileType) {
    return previous.then(function () {
      return dispatch(updateProfile({
        profileType: profileType,
        data: updates[profileType],
        showMessages: false,
        meta: {
          update: updates[profileType]
        }
      }));
    });
  }, Promise.resolve());
};